import { Id, ShiftsResponse as Response, Shift } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { convertShiftList } from './shared/convert'
import keys from './shared/keys'

export function useRatingsList(storeId?: Id) {
  const { server } = useServer()
  return useQuery<Array<Shift>>({
    queryKey: storeId ? keys.list(storeId) : [],
    queryFn: fetchRatingsList,
  })

  async function fetchRatingsList() {
    if (!storeId) {
      throw new Error('Illegal store ID')
    }

    const response = await server.get<Response.Shift[]>(
      `/v2/managers/me/shifts/${storeId}/unrated_shifts`
    )

    return convertShiftList(response)
  }
}
